import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const getExtensionFile = (filename: any) => {
    return (filename.match(/\.[0-9a-zA-Z]+$/i)) ? filename.match(/\.[0-9a-zA-Z]+$/i)[0] : 0;
}

export function fileUpload(files:FileList):ValidatorFn {
    return (control:AbstractControl): ValidationErrors|null => {
         var invalidFileType = false;
        Array.from(files).forEach((file: File) => {
            var allowedFileTypes = [".pdf",".png",".svg",".jpg",".jpeg"];
            if((file.name.length != 0) && !allowedFileTypes.includes(getExtensionFile(file.name)))
                invalidFileType  = true;
        });
        if(invalidFileType)
            return {'fileUpload': 'File type not supported. Please upload a file of type PDF, PNG, SVG, JPG, or JPEG.'}
        return null;
        
    }
}